<script>

import Service from '@/services/planning';
import ResponsiveButton from '@/components/generic/ResponsiveButton.vue';
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import GenericCustomAutocompleteV2 from '@/components/generic/GenericCustomAutocompleteV2.vue';

import CommonConstants from '@/common/Constants';
import Utils from '@/common/Utils';
import { FilterMatchMode } from 'primevue/api';

export default{
    // props: ['showCreate', 'showLink', 'idMovementInstructionHeader', 'startDate', 'endDate'],
    emits: ['hideDialog'],
    components: {
        ResponsiveButton,
        // GenericCustomMasterDataAutocompleteV2,
        // GenericCustomAutocompleteV2

    },
    created(){
    },
    mounted(){
        
    },
    data(){
        return{
            data: [],
            showUpload: true,
            showPreview: false,
            importDate: null
        }
    },
    computed: {
        constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        }
    },
    methods: {
        async onParseFile(file){

            let formData = new FormData();
            formData.append('inputFile', file.files[0]);

            this.$store.dispatch("generic/setLoading", true);
            Service.importOperativeLevelsExcelParse(formData, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.showUpload = false;
                    this.showPreview = true;
                    this.data = response.data
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        performImport(){
            if(this.importDate){
                this.$confirm.require({
                    message: this.$t('messages.confirm_import'),
                    icon: 'pi pi-exclamation-triangle',
                    acceptLabel: this.$t('yes'),
                    rejectLabel: this.$t('no'),
                    accept: () => {

                        if(this.data.ISABSUD && this.data.ISABSUD.length){
                            let bodySud = {
                                lastUpdateDate: this.importDate,
                                tankLevelsList: [...this.data.ISABSUD],
                                plant: 'ISABSUD'
                            };
                            
                            Service.importOperativeLevelsExcel(bodySud, response => {

                                let emitResponse = {
                                    plant: 'ISABSUD',
                                    success: response.success,
                                    message: response.message
                                }
                                this.$emit('hideDialog', emitResponse);
                                if(response.success){
                                    this.$toast.add({detail: this.$t('operativeLevels.importSudSuccess'), life:3000, severity:'success'});
                                }else{
                                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                }
                            });
                        }

                        if(this.data.ISABNORD && this.data.ISABNORD.length){
                            let bodyNord = {
                                lastUpdateDate: this.importDate,
                                tankLevelsList: [...this.data.ISABNORD],
                                plant: 'ISABNORD'
                            };
                            
                            Service.importOperativeLevelsExcel(bodyNord, response => {
                                let emitResponse = {
                                    plant: 'ISABNORD',
                                    success: response.success,
                                    message: response.message
                                }
                                this.$emit('hideDialog', emitResponse);
                                if(response.success){
                                    this.$toast.add({detail: this.$t('operativeLevels.importNordSuccess'), life:3000, severity:'success'});
                                }else{
                                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                                }
                            });
                        }
                    },
                    reject: () => {
                        //callback to execute when user rejects the action
                        this.$confirm.close();
                    }
                });
            }else{
                this.$toast.add({detail: this.$t('messages.importDateRequired'), life:3000, severity:'error'});
            }
        }
    }
}

</script>

<template>
    <main>
        <div class="grid">
            <div class="col-12" v-if="showUpload">
                <FileUpload name="uploaded[]" :customUpload="true" @uploader="onParseFile" :previewWidth="0" :fileLimit="1" :multiple="false" />      
            </div>

            <div class="col-12" v-if="showPreview">
                <div class="grid">
                    <div class="col-4 field">
                    <label for="startDate">{{$t('startDate')}}</label>
                    <Calendar 
                        :placeholder="constants.DATE_FORMAT_POINT"
                        :dateFormat="constants.DATE_FORMAT_POINT"
                        :showTime="false" :hideOnDateTimeSelect="true"
                        id="startDate" 
                        v-model="importDate"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true"
                        :class="{'w-full p-inputtext-sm mt-1 ': true}" />
                    <ResponsiveButton :label="$t('btn.import')" icon="pi pi-file" @click="performImport" class="p-button-sm p-button-outlined m-1" />
                </div>
            </div>
                <TabView>
                    <TabPanel v-for="(value, name, index) in data" :key="index" :header="name">
                        <DataTable :value="value" scrollable :responsiveLayout="'scroll'" breakpoint="960px" rsortMode="single"
                            sortField="tankCode" :sortOrder="1" size="small">
                            <Column field="tankCode" :header="$t('StockManagementDailyTank.tankcode')" />
                            <Column field="referenceLevel" :header="$t('operativeLevels.referenceLevel')" />
                            <Column field="maxOperativeLevel" :header="$t('operativeLevels.maxOperativeLevel')" />
                            <Column field="minOperativeLevel" :header="$t('operativeLevels.minOperativeLevel')" />
                            <Column field="conversionFactor" :header="$t('operativeLevels.conversionFactor')" />
                        </DataTable>
                    </TabPanel>
                </TabView>
            </div>
        </div>
    </main>
</template>